import { MainContainer } from "../../component/container";
import Tm1 from '../../assets/person/Tm1.jpg'
import BouncingIcon from "../../component/BouncingIcon";
import Teams from '../../assets/image/tm.jpg'
import FK from '../../assets/person/fk.jpg'
import PN from '../../assets/person/pn.jpg'
import EWB from '../../assets/person/ewb.jpg'
import FK_PN from '../../assets/person/fk_pn.jpg'
import JN from '../../assets/person/jn.jpg'
import UC from '../../assets/person/uc.jpg'
import { Element, Link } from 'react-scroll';

export default function Team() {

    const Sec1 = () => {
        return (
            <>
                Sokoloni F. Kamba, the ACRFI Founder, is a Congolese American, born in Congo, DRC and currently living in Miami, Florida. He founded the ACRFI, together with his wife Patience M.N.Kamba back in the year 2000, right after the death of his father Sylvain Kabuanseya. The death of his father brought back in his memory the love for the less fortunate people that his late father taught him many years ago as shown above, volunteering as a young medical intern in the remote countryside villages' campaign to cure tropical diseases. Franck is a husband, a father and a grand uncle to many children. His love for families and children has kept him passionate for the success of any children around him.
            </>
        )
    }

    return (
        <MainContainer page='CONTACT'>
            <div id='content' className="">
                <img src={Teams} alt="Team" className='w-screen h-screen object-cover opacity-70' />

                <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                    <div className="bg-[#87ceeb] bg-opacity-70 p-4 rounded-full">
                        <h1 className="text-lg sm:text-4xl font-bold text-white text-center">THE ACRFI in MIAMI, FLORIDA.</h1>

                    </div>
                </div>


                <Link to="Scroll" smooth={true} duration={500}>
                    <BouncingIcon />
                </Link>
            </div>
            <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>
            <div className="2xl:px-80 xl:px-52 px-10 mb-32 mt-24">
                <div className='text-center font-extrabold text-[#2E51A9] mt-3 text-2xl'>
                    The Miami Team is the Headquarter of the foundation, located in Miami, Florida.
                </div>

                <div className="flex justify-center flex-col sm:flex-row gap-2 mt-5">
                    <div className="flex flex-col text-center">
                        Below is our contact:

                        <span className="font-bold ">The ACRFI-MIAMI</span>
                        <span>1167 NW 49th street</span>
                        <span>Miami, FL. 33127-2229</span>

                        <span className="mt-4">Tel: 305-607-2284</span>
                        <span>Fax: 305-633-0094</span>
                        <span>E-mail: admin@theacrfi.org</span>
                        <span>www.theacrfi.org</span>
                    </div>

                    <img src={Tm1} alt={'Tm1'} className='' />
                </div>


                <div className=" flex flex-col gap-10 text-center">
                    <div className=' font-extrabold text-[#2E51A9] mt-3 text-2xl'>
                        The headquarter team of the ACRFI is composed of:
                    </div>




                    <div className="flex flex-col justify-center">
                        <div className="flex md:flex-row flex-col gap-2 justify-between items-center">
                            <div className="flex md:flex-row flex-col items-center gap-5">
                                <div>
                                    <div className="font-bold">Sokoloni Franck Kamba</div>
                                    <img src={FK} alt={'FK'} className='min-w-80 min-h-80 w-80 h-80' />
                                </div>
                                <span className="flex md:hidden xl:flex items-center text-center ">
                                    <Sec1 />
                                </span>
                            </div>
                            <img src={FK_PN} alt={'FK_PN'} className='min-w-80 min-h-80 w-80 h-80' />
                        </div>
                        <span className="hidden md:flex xl:hidden items-center text-center ">
                            <Sec1 />
                        </span>
                    </div>

                    <div className="">
                        To satisfy his desire to help others succeed, Dr Kamba has been giving his personal time to care for the needy people of his communities starting in the Congo DRC as a member of diverse philanthropic organizations such as ROTARACT CLUB in Katanga States (Rotaract Club President in the year 1995-1996, participating in the International Rotary Club vaccination campaign to eradicate polio in Africa..) as well as a volunteer MD in the effort of Salesienne missionary nuns to cure tropical diseases in the Katanga Province), etc..
                    </div>

                    <div>
                        Academically, the ACRFI Founder has earned an MD degree from the University of Lubumbashi, Congo DRC, and a BSN in the State of Florida.
                    </div>

                    <div>
                        Franck is currently working at JHS in Miami Florida and spends most of his free time searching for ways to assist street children in US and in the Congo DRC, via this [501 (C) (3)], Non Profit Organization he founded and incorporated in Florida since march, 2008. His most desire is giving back to the community, everything the course of his life has blessed him with, as a person and to end poverty by any godly given mean!
                    </div>

                    <div>
                        The care for the orphans of his home Country is such a burden in his heart, that his yearly vacations take him back to the mother land of Africa where he brings help, love & hope to the few among hundreds of thousands of orphans of the Democratic Republic of Congo, he believes will all be free one day with God's help. In Miami, Franck is been participating at different seminaries concerning ways to resolve issues of Street children in Florida.
                    </div>

                    <div className="flex items-center md:flex-row flex-col gap-5">
                        <div className="">
                            <div className=" font-bold">Patience M.N. Kamba</div>
                            <img src={PN} alt={'PN'} className='min-w-80 min-h-80 w-80 h-80' />
                        </div>
                        <div className="flex flex-col gap-5 items-center justify-center">
                            <span>
                                Patience Kamba, Cofounder of the ACRFI, is also a Congolese American and a passionate mother whose love for children and the less fortunate in her community define her character. A former Medical student in the Congo, Patience is currently employed as a nurse in Miami, Florida.
                            </span>
                            <span>
                                Below, the Cofounder is visiting our pioneer orphans in Katanga, with the ACRFI-Katanga Representative, Mme Christine T. Senda(July 2011)
                            </span>
                        </div>
                    </div>



                    <div className="flex items-center lg:flex-row flex-col gap-5">
                        <div className="">
                            <div className=" font-bold">Evelina W. Bestman</div>
                            <img src={EWB} alt={'EWB'} className='min-w-80 min-h-80 w-80 h-80' />
                        </div>
                        <div className="flex flex-col gap-5 items-center justify-center">
                            <span>
                                Dr. Bestman, the ACRFI Treasurer & Financial Director, is a Bahamian American, born in Miami and a Florida resident. For her love for children and her passion to help people of middle and low classes, Evelina is known to be one exceptional Auntie and godmother to multitude! A former member of the board of directors at Jackson Memorial Hospital and CEO of New Horizon for 30 plus years, a company that assist people of middle and low classes in Miami, Florida, Dr. Bestman runs her own business in Miami as a Psychologist. And beside her busy days, she always find a little time to care for the welfare of her multiple godchildren, nieces and nephews, as well as the street kids through our foundation,the ACRFI, as a member of the board of directors. With her experience dealing with unfortunate people of low classes in our community, her passionate practice as a psychologist, Dr. Bestman is been a great asset to this non profit organization, the ACRFI, as we care for the street and abandoned children here at home, and the multitude orphans in the Congo DRC.
                            </span>
                        </div>
                    </div>



                    <div className="flex items-center md:flex-row flex-col gap-5">
                        <div className="">
                            <div className=" font-bold">Julienne N. Kabuanseya</div>
                            <img src={JN} alt={'JN'} className='min-w-80 min-h-80 w-80 h-80' />
                        </div>
                        <div className="flex flex-col gap-5 items-center justify-center">
                            <span>
                                Julienne, the ACRFI Human resources Director, is a Florida Resident, born in the Congo DRC and living in Miami, Florida.
                            </span>
                        </div>
                    </div>

                    <div className="flex items-center md:flex-row flex-col gap-5">
                        <div className="">
                            <div className=" font-bold">Michele Abraham</div>
                            <img src={UC} alt={'UC'} className='min-w-80 min-h-80 w-80 h-80' />
                        </div>
                        <div className="flex flex-col gap-5 items-center justify-center">
                            <span>
                                Michele, the ACRFI Executive Director is a Haitian American and a Florida resident.
                            </span>
                        </div>
                    </div>

                </div>

            </div>
        </MainContainer>
    )
}